import React from 'react'
import { Button, Table, Pagination } from 'semantic-ui-react'
import {getPP, getVehicle} from "../misc/Helpers";

function ReportTable({ reports, handleDeleteReport, handleReportPaginationChange }) {
  let reportList
  let activePage
  let totalPages
  if (!reports) {
    reportList = (
      <Table.Row key='no-user'>
        <Table.Cell collapsing textAlign='center' colSpan='11'>Нет отчетов</Table.Cell>
      </Table.Row>
    )
  } else {
    activePage = reports.number
    totalPages = reports.totalPages
    reportList = reports.content.map(report => {
      return (
        <Table.Row key={report.id}>
          <Table.Cell collapsing>
            <Button
              circular
              color='red'
              size='small'
              icon='trash'
              onClick={() => handleDeleteReport(report.id)}
            />
          </Table.Cell>
          <Table.Cell>{report.id}</Table.Cell>
          <Table.Cell>{getPP(report.pp)}</Table.Cell>
          <Table.Cell>{getVehicle(report.vehicleType)}</Table.Cell>
          <Table.Cell>{new Date(report.tripDate).toLocaleString('ru',
            { year: 'numeric', month: 'short', day: 'numeric' })}</Table.Cell>
          <Table.Cell>{report.startHour}:{report.startMin}</Table.Cell>
          <Table.Cell>{report.firstBorderHour}:{report.firstBorderMin}</Table.Cell>
          <Table.Cell>{report.secondBorderHour}:{report.secondBorderMin}</Table.Cell>
          <Table.Cell>{report.total}</Table.Cell>
          <Table.Cell>{report.author.username}</Table.Cell>
          <Table.Cell>{report.author.phone}</Table.Cell>
        </Table.Row>
      )
    })
  }

  return (
    <>
      <Table compact striped selectable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={1}/>
            <Table.HeaderCell width={1}>ID</Table.HeaderCell>
            <Table.HeaderCell width={3}>ПП</Table.HeaderCell>
            <Table.HeaderCell width={4}>Транспорт</Table.HeaderCell>
            <Table.HeaderCell width={5}>Дата</Table.HeaderCell>
            <Table.HeaderCell width={2}>Выехали</Table.HeaderCell>
            <Table.HeaderCell width={2}>Первая граница</Table.HeaderCell>
            <Table.HeaderCell width={2}>Вторая граница</Table.HeaderCell>
            <Table.HeaderCell width={2}>Всего</Table.HeaderCell>
            <Table.HeaderCell width={2}>Автор</Table.HeaderCell>
            <Table.HeaderCell width={2}>Тел</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {reportList}
        </Table.Body>
      </Table>
      <Pagination
        activePage={activePage+1}
        boundaryRange={1}
        onPageChange={handleReportPaginationChange}
        size='mini'
        totalPages={totalPages}
      />
    </>
  )
}

export default ReportTable
